// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#282936"};